import { gql } from '@apollo/client';

export const searchTaxations = gql`
  query searchTaxations(
    $keyword: String
    $pagination: PaginationInput
    $orderBy: OrderByInput
    $lines: [String!]
    $effectiveDateFrom: DateTime
    $effectiveDateTo: DateTime
    $createdOnFrom: DateTime
    $createdOnTo: DateTime
  ) {
    core {
      searchTaxations(
        keyword: $keyword
        pagination: $pagination
        orderBy: $orderBy
        lines: $lines
        effectiveDateFrom: $effectiveDateFrom
        effectiveDateTo: $effectiveDateTo
        createdOnFrom: $createdOnFrom
        createdOnTo: $createdOnTo
      ) {
        items {
          id
          applicableToAllPlans
          code
          createdBy
          createdOn
          modifiedOn
          effectiveFrom
          effectiveTo
          fixedStamp
          fixedStampCurrency
          isLatest
          lineID
          municipalityTax
          proportionalStamp
          reinsuranceTax
          taxOnCommission
          fixedStampCurrencyValue {
            code
            symbol
            title
          }
          line {
            id
            code
            name
            abbreviation
          }
          taxationPlansSpecific {
            id
            planID
            fixedStamp
            fixedStampCurrency
            proportionalStamp
            municipalityTax
            taxOnCommission
            reinsuranceTax
            fixedStampCurrencyValue {
              id
              title
              symbol
            }
            plan {
              id
              code
              name
            }
          }
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

export const getLines = gql`
  query getLines(
    $keyword: String
    $pagination: PaginationInput
    $orderBy: OrderByInput
    $statuses: [String!]
    $createdOnStart: DateTime
    $createdOnEnd: DateTime
  ) {
    planConfig {
      getLines(
        keyword: $keyword
        pagination: $pagination
        orderBy: $orderBy
        statuses: $statuses
        createdOnStart: $createdOnStart
        createdOnEnd: $createdOnEnd
      ) {
        items {
          id
          code
          name
          status
        }
      }
    }
  }
`;





export const getTaxationPlanSpecific = gql`
  query getTaxationPlanSpecific(
    $lineId: String!
    $planId: String!
    $taxationId: String!
  ) {
    core {
      getTaxationPlanSpecific(
        lineId: $lineId
        planId: $planId
        taxationId: $taxationId
      ) {
        fixedStamp
        fixedStampCurrency
        proportionalStamp
        municipalityTax
        reinsuranceTax
        taxOnCommission
      }
    }
  }
`;

export const getLatestTaxationByLine = gql`
  query getLatestTaxationByLine($lineId: String!) {
    core {
      getLatestTaxationByLine(lineId: $lineId) {
        applicableToAllPlans
        code
        createdBy
        createdOn
        effectiveFrom
        effectiveTo
        fixedStamp
        fixedStampCurrency
        id
        isLatest
        lineID
        modifiedBy
        modifiedOn
        municipalityTax
        proportionalStamp
        reinsuranceTax
        taxOnCommission
      }
    }
  }
`;

export const getTaxationDetailsInfo = gql`
  query getTaxationDetailsInfo($id: String!) {
    Configuration {
      entities {
        taxation(id: $id) {
          views {
            Configuration_all {
              properties {
                LineID {
                  id
                  views {
                    PlanConfigManagement_all {
                      properties {
                        ExternalCode
                        Name
                        Status
                      }
                    }
                  }
                }
                Id
                TaxOnCommission
                ReinsuranceTax
                EffectiveFrom
                EffectiveTo
                IsLatest
                FixedStamp
                FixedStampCurrency {
                  Code
                  Title
                  Id
                }
                ProportionalStamp
                MunicipalityTax
                ApplicableToAllPlans
                CustomRepeater
                createdBy
                createdOn
                modifiedBy
                modifiedOn
              }
            }
          }
        }
      }
    }
  }
`;

export const getTaxationDetails = gql`
  query getTaxationDetails($id: String!) {
    core {
      getTaxationDetails(taxationId: $id) {
        applicableToAllPlans
        code
        createdBy
        createdOn
        effectiveFrom
        effectiveTo
        fixedStamp
        fixedStampCurrency
        fixedStampCurrencyValue {
          code
          createdOn
          id
          modifiedOn
          status
          symbol
          title
          titleAr
        }
        id
        isLatest
        line {
          abbreviation
          abbreviationArabic
          code
          createdBy
          createdOn
          id
          modifiedBy
          modifiedOn
          name
          nameArabic
          status
        }
        lineID
        modifiedBy
        modifiedOn
        municipalityTax
        proportionalStamp
        reinsuranceTax
        taxOnCommission
      }
    }
  }
`;

export const searchTaxationPlanSpecific = gql`
  query searchTaxationPlanSpecific(
    $taxationId: String!
    $keyword: String!
    $pagination: PaginationInput!
    $orderBy: OrderByInput!
  ) {
    core {
      searchTaxationPlanSpecific(
        taxationId: $taxationId
        keyword: $keyword
        pagination: $pagination
        orderBy: $orderBy
      ) {
        items {
          createdBy
          createdOn
          fixedStamp
          fixedStampCurrency
          id
          lineID
          modifiedBy
          modifiedOn
          municipalityTax
          planID
          proportionalStamp
          reinsuranceTax
          taxationID
          taxOnCommission
          fixedStampCurrencyValue {
            symbol
          }
          plan {
            name
            code
          }
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;



